const SCREEN = {
  XSMALL: '0px',
  SMALL: '769px',
  MEDIUM: '1080px',
  LARGE: '1200px',
  XLARGE: '1600px',
};

export default SCREEN;
